<template>
  <button class="dg_btn btn_view" @click="view('Return_Asset_View')">檢視</button>
  <button :class="['dg_btn', { 'disabled': isDisabled.edit, 'btn_edit': !isDisabled.edit }]" :disabled="isDisabled.edit" @click="view('Return_Asset_Edit')">編輯</button>
  <button :class="['dg_btn', { 'disabled': isDisabled.inbound, 'btn_inbound': !isDisabled.inbound }]" :disabled="isDisabled.inbound" @click="view('Return_Asset_Inbound')">入庫</button>
</template>

<script setup>
import { Return_Asset_Edit, Return_Asset_InBound } from '@/assets/js/enter_status';
import router from '@/router';
import { onMounted, reactive } from 'vue';

const props = defineProps(['params']);
const search_id = props.params.data.RR_ID;
const status = props.params.data.ReturnStatus;
const isDisabled = reactive({
  edit: false, //編輯
  inbound: false, //入庫
});
const view = (name) => {
  router.push({ name: name, query: { search_id } });
}
const checkButton = () => {
  if (!Return_Asset_Edit.includes(status) || !props.params.data.canEdit) {
    isDisabled.edit = true;
  }
  if (!Return_Asset_InBound.includes(status) || !props.params.data.canAssetsIn) {
    isDisabled.inbound = true;
  }
}
onMounted(() => {
  checkButton();
})
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.btn_view {
  @include datagrid_view_button;

  &:hover {
    background: #1D7072;
    color: white;
  }
}

.btn_edit {
  @include datagrid_edit_button;

  &:hover {
    background: #3B6162;
    color: white;
  }
}

.btn_inbound {
  @include datagrid_pass_button;

  &:hover {
    background: #597c7c;
    color: white;
  }
}

.disabled {
  @include disabled_btn;
  width: 50px;

  &:hover {
    @include disabled_btn;
    width: 50px;
    height: 25px;
  }
}

.dg_btn {
  height: 25px;
}
</style>
